<div class="odf-dialog">
  <!-- Header -->
  <div class="odf-header">
    <div class="odf-header-left">
      <div class="odf-header-icon">
        <mat-icon>folder_zip</mat-icon>
      </div>
      <div>
        <h5 class="odf-title">Download Documents</h5>
        <p class="odf-subtitle">Select documents to download, grouped by department.</p>
      </div>
    </div>
    <button type="button" class="odf-close" (click)="close()" title="Close">✕</button>
  </div>

  <!-- Toolbar -->
  <div class="odf-toolbar" *ngIf="totalFiles > 0">
    <label class="odf-selectall">
      <span class="odf-checkbox" [class.checked]="allSelected" (click)="toggleAll()">
        <mat-icon *ngIf="allSelected">check</mat-icon>
      </span>
      <span>Select all</span>
    </label>

    <label class="odf-selectall">
      <span class="odf-checkbox" [class.checked]="latestOnlySelected" (click)="toggleLatestAll()">
        <mat-icon *ngIf="latestOnlySelected">check</mat-icon>
      </span>
      <span>Select latest versions</span>
    </label>
    <span class="odf-count">{{ selectedCount }} of {{ totalFiles }} selected</span>
  </div>

  <!-- Department list -->
  <div class="odf-body">
    <ng-container *ngIf="totalFiles > 0; else emptyState">
      <div class="odf-dept" *ngFor="let dept of departments">
        <div class="odf-dept-head" (click)="toggleDeptExpand(dept)">
          <button type="button" class="odf-chevron" [class.open]="isDeptExpanded(dept)" aria-label="Expand or collapse department">
            <mat-icon>chevron_right</mat-icon>
          </button>
          <span class="odf-checkbox" [class.checked]="isDeptAllSelected(dept)" (click)="toggleDept(dept, $event)">
            <mat-icon *ngIf="isDeptAllSelected(dept)">check</mat-icon>
          </span>
          <div class="odf-dept-name">{{ dept.departmentName }}</div>
          <span class="odf-dept-count">{{ getDeptSelectedCount(dept) }}/{{ dept.files.length }}</span>
        </div>

        <div class="odf-files" *ngIf="isDeptExpanded(dept)">
          <div
            class="odf-file"
            *ngFor="let file of dept.files"
            [class.selected]="isFileSelected(file.id)"
            (click)="toggleFile(file.id)"
            role="button"
          >
            <span class="odf-checkbox" [class.checked]="isFileSelected(file.id)">
              <mat-icon *ngIf="isFileSelected(file.id)">check</mat-icon>
            </span>
            <span class="odf-file-icon">
              <ng-container [ngSwitch]="iconType(file.fileName)">
                <!-- PDF -->
                <svg *ngSwitchCase="'pdf'" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                  <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                  <path d="M10 9H8"></path>
                  <path d="M16 13H8"></path>
                  <path d="M16 17H8"></path>
                </svg>
                <!-- XLS -->
                <svg *ngSwitchCase="'xls'" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                  <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                  <path d="M10 9H8"></path>
                  <path d="M16 13H8"></path>
                  <path d="M16 17H8"></path>
                </svg>
                <!-- DOC -->
                <svg *ngSwitchCase="'doc'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                  <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
                  <path d="M10 9H8"></path>
                  <path d="M16 13H8"></path>
                  <path d="M16 17H8"></path>
                </svg>
                <!-- IMAGE -->
                <svg *ngSwitchCase="'image'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
                  <circle cx="9" cy="9" r="2"></circle>
                  <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                </svg>
                <!-- DEFAULT -->
                <svg *ngSwitchDefault width="20" height="20" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M4 2.5h12l5 5v12.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1z" fill="none" stroke="#7c3aed" stroke-width="1.6" stroke-linejoin="round" />
                </svg>
              </ng-container>
            </span>
            <div class="odf-file-body">
              <div class="odf-file-name">{{ file.fileName }}</div>
              <div class="odf-file-sub">
                <span class="odf-file-ver">v{{ file.versionNumber }}</span>
                <span *ngIf="file.status" class="odf-file-status">{{ file.status }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #emptyState>
      <div class="odf-empty">
        <mat-icon>folder_off</mat-icon>
        <span>No documents available to download.</span>
      </div>
    </ng-template>
  </div>

  <!-- Footer -->
  <div class="odf-footer">
    <button type="button" class="odf-btn odf-btn-cancel" (click)="close()">Cancel</button>
    <button type="button" class="odf-btn odf-btn-download" [disabled]="selectedCount === 0" (click)="download()">
      <mat-icon>download</mat-icon>
      Download<span *ngIf="selectedCount > 0"> ({{ selectedCount }})</span>
    </button>
  </div>
</div>
